export const ORDER_FORM_ROOT = 'order-management';
export const SALES_ORDER_DETAILS = (businessId: string, orderId: string) =>
  `/${ORDER_FORM_ROOT}/${businessId}/info/${orderId}`;
export const SALES_ORDER_CREATE = (businessId: string) => `/${ORDER_FORM_ROOT}/${businessId}/sales-order/create`;
export const SALES_ORDER_SUMMARY = (businessId: string, orderId: string) =>
  `/${ORDER_FORM_ROOT}/${businessId}/sales-order/${orderId}`;
export const SALES_ORDER_SUBMITTED = (businessId: string, orderId: string) =>
  `/${ORDER_FORM_ROOT}/${businessId}/sales-order/${orderId}/submitted`;
export const BUSINESS_DETAILS = (businessId: string) => `/businesses/accounts/${businessId}/details`;

export const ALL_SALES_ORDERS = `/${ORDER_FORM_ROOT}`;

export function buildOrdersPageForBusinessQuery(accountGroupId: string): Record<string, string> {
  return {
    'sales-orders': encodeURIComponent(JSON.stringify({ businessId: accountGroupId })),
  };
}
